import { render, staticRenderFns } from "./UserBadges.vue?vue&type=template&id=b4bae1d6&scoped=true&"
import script from "./UserBadges.vue?vue&type=script&lang=js&"
export * from "./UserBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bae1d6",
  null
  
)

export default component.exports